import Head from "next/head";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { ExtendedNextPage } from "types/pages";

import HummingNav from "pages/components/HummingNav";
import HummingFooter from "pages/components/HummingFooter";
import Label from "components/Label";
import Content from "components/Content";
import { getPosts, getTags, Post, Tag } from "utils/content/blog";

import MainHeader from "./components/MainHeader";
import Posts from "./components/Posts";
import styles from "./styles.module.scss";

const Blog: ExtendedNextPage = () => {
  const [posts, setPosts] = useState<Array<Post>>([]);
  const [tags, setTags] = useState<Array<Tag>>([]);

  async function fetchPosts() {
    const data = await getPosts();
    setPosts(data);
  }

  async function fetchTags() {
    const data = await getTags();
    setTags(data.items);
  }

  useEffect(() => {
    fetchPosts();
    fetchTags();
  }, []);

  return (
    <div className={styles.container}>
      <Head>
        <title>Blog | Humming Homes</title>
        <meta
          name="description"
          content="We're industry experts, with a focus on ensuring any homeowner has the perfect set of information related to home services. From guides, to expert advice to comparisons, we've got you covered."
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://humminghomes.com/blog" />
      </Head>

      <MainHeader />

      <Content contentClassName={styles.posts}>
        <div className={styles.postsHeader}>
          {tags && (
            <div className={styles.postsHeaderSection}>
              <Label variant="s" className={styles.sectionLabel}>
                Explore
              </Label>
              <ul className={styles.tagList}>
                {tags.map((tag) => (
                  <li key={tag.sys.id}>
                    <Link
                      href={`/blog/tag/${tag.sys.id
                        .replace(/([A-Z])/g, "-$1")
                        .toLowerCase()}`}
                      className={styles.tag}
                    >
                      <Label
                        variant="s-capitalized"
                        className={styles.tagLabel}
                      >
                        {tag.name}
                      </Label>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <Posts posts={posts} tags={tags} />
      </Content>
    </div>
  );
};

Blog.getLayout = (page) => {
  return (
    <div>
      <HummingNav />
      {page}
      <HummingFooter />
    </div>
  );
};

export default Blog;
